module.exports = __webpack_public_path__ + "img/bar1.5018f9b3.png";